/* eslint-disable */

/**监听内容组件标签栏和地址栏标题端点击事件
 * @xiaoli
 */

import apiServer from "../../tools/apiServer";
import vue_comp from "./home_template";

export default function addEvent(){
  let tagsTitles = document.querySelectorAll('.tags-title');
  let citysTitles = document.querySelectorAll('.city-title');
  let changeRecommendData = document.querySelector('.changeRecommendData');


  tagsTitles && tagsTitles.forEach((node) => {
    node.addEventListener('click', function(e){
      tagsClick(e, 'tag');
    });
  })

  citysTitles && citysTitles.forEach((node) => {
    node.addEventListener('click', function(e){
      tagsClick(e, 'city');
    });
  })

  changeRecommendData && changeRecommendData.addEventListener('click', function(e){
    getRecommendTpl();
  })

  let i= document.getElementsByClassName('tags_select');
  i[0].click();

}
  /**
   * 事件代理
   */
  function tagsClick(e, type) {
    console.log('my-click');
    let target = e.target;
    if (target.tagName === 'LI') {
      let text = target.dataset.tag_title;
      let titleList  = getTitleList(target);
      getTempData(target, text, titleList, type);
      showHover(e.target);
    }
  }

  async function getTempData (target, text, titleList, type) {
    while(target) {
      if (target.classList && target.classList.contains('vue_temp')) {
        let temp_data=null;
        let el = target;
        let temp = await apiServer.getVueTpl();
        if (type=='city') {
          temp_data = await getCityData(text);
        } else if(type=='tag'){
          temp_data = await getTagData(text);
          console.log(temp);
        }
        console.log(temp_data)
        if (temp && temp_data && temp_data.t) {
          mountEl(temp, el, temp_data.t, titleList, type);
        }
        break;
      };
      target = target.parentNode;
    }
  }
/**
 * 
 * @param {String} tag_name 获取标签对应内容
 */
function getTagData(tag_name) {
  return apiServer.getTagData(tag_name)
}
function getCityData(city_name) {
  return apiServer.getCityData(city_name)
}
  /**
   * 控制颜色
   */
  function showHover(node) {
    let sibling = siblings(node);
    for(let j = 0; j < sibling.length; j++){
      if(sibling[j]==node) {
        node.classList && node.classList.add('hover');
      }
      sibling[j].classList.remove('hover');
    }  
  }

  // function isContainer(target) {
  //   return target.classList.contains('tags-title') || target.classList.contains('city-title')
  // }

  function siblings(elm){
    return elm.parentNode.children; //获取父级的所有子节点
  }

  /**建立组件 */
  function mountEl(template, el, tpl_data, titleList, type) {
    vue_comp.createHomeTpl(template, el, tpl_data, titleList, type)
  }

  function getTitleList(node) {
    let list = [];
    let nodeList = siblings(node);
    for (let i = 0; i < nodeList.length;i++){
      let text = nodeList[i].innerText;
      if (text == '推荐') {
        text = nodeList[i].dataset.tag_title;
      }
      list.push(text);
    }
    return list;
  }

  async function getRecommendTpl () {
    let data = await apiServer.getRecommendTpl();
    let changeRecommend = document.querySelector('.changeRecommend');
    vue_comp.createCommendTpl(data, changeRecommend);
  }

